(($, Drupal, once) => {
  'use strict';

  Drupal.behaviors.video_modal = {
    attach: function(context, settings) {
      const videoMaxWidth = 700;
      let $video_modal_trigger = $('.remote-video-button');

      const sizeVideoFrame = function($iframe, height, width) {
        // set iframe size
        // ensure 32px around to click off
        var w = Math.min(videoMaxWidth, (window.innerWidth));

        var h = height * (w / width);
        var headerHeight = $('.hero-basic').height();
        var winHeight = window.innerHeight - headerHeight;

        if (h > (winHeight - 64)) {
          h = winHeight - 64;
          w = width * (h / height);
        }

        $iframe.attr('height', Math.floor(h));
        $iframe.attr('width', Math.floor(w));
      };

      const focusTrap = function($modal) {
        // Variables to store the modal and iframe elements
        let $focusable_items,
            $firstFocusable,
            $lastFocusable;

        // Store the elements that can receive focus within the iframe
        $focusable_items = $modal.find('button, input, select, textarea, a[href]');

        // Get the first focusable element within the modal
        $firstFocusable = $focusable_items.first();

        // Get the last focusable element within the modal
        $lastFocusable = $focusable_items.last();

        // Trap focus within the modal when it is open
        // Set focus to the first focusable element within the modal
        $firstFocusable.focus();

        $lastFocusable.on('focus', function(event) {
          event.preventDefault();
          $firstFocusable.focus();
        });

        // Override the default tab behavior within the modal
        $modal.on('keydown', function(e) {
          if (e.key === 'Tab') {
            //Tab pressed, move focus to the previous focusable element
            if (document.activeElement === $lastFocusable[0]) {
              e.preventDefault();
              $firstFocusable.focus();
            }

            if (e.shiftKey) {
              // Shift+Tab pressed, move focus to the previous focusable element
              if (document.activeElement === $firstFocusable[0]) {
                e.preventDefault();
                $firstFocusable.focus();
              }
            }
          }
        });
      };

      const buttonLoadVideo = function($btn) {
        const src = $btn.attr('data-src');
        const title = $btn.attr('data-title');
        const width = $btn.attr('width');
        const height = $btn.attr('height');
        const $iframe = $('<iframe allowfullscreen></iframe>');
        const toOverlay = $btn.attr('data-video-overlay') === 'true';
        $iframe.attr('height', height);
        $iframe.attr('width', width);
        $iframe.attr('allow', 'autoplay');
        var symbol = src.indexOf('?') > -1 ? '&' : '?';
        $iframe.attr('src', src + symbol + 'autoplay=1');
        $iframe.attr('title', title);
        $iframe.attr('accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');

        if (toOverlay) {
          const $overlay = $('<div class="video-player-overlay"></div>');
          const $video_dismiss = $('<div class="video-dismiss"></div>');
          const $video_wrap = $('<div class="video-wrap" id="video-modal"></div>');
          const $close_video = $('<button class="close-video"><span class="sr-only">Close</span><i class="fa-solid fa-xmark"></i></button>');
          const $focus_end = $('<a href="#"></a>');
          $(once('close-video-modal', $video_dismiss)).on('click', function() {
            $(this).parent().remove();
            $('html').removeClass('no-scroll');
          });

          $(once('close-video-modal-button', $close_video)).on('click', function() {
            $(this).parent().parent().remove();
            $('html').removeClass('no-scroll');
          });

          // set positions
          $overlay.append($video_dismiss);
          $video_wrap.append($close_video);
          $video_wrap.append($iframe);
          $video_wrap.append($focus_end);
          if (window.innerWidth < videoMaxWidth) {
            $video_wrap.addClass('full-width');
          }
          $overlay.append($video_wrap);
          $('#main-canvas').append($overlay);
          $('html').addClass('no-scroll');
          sizeVideoFrame($iframe, height, width);
          focusTrap($('#video-modal'));
        }
        else {
          $btn.replaceWith($iframe);
        }
      };

      $(once('open-modal', $video_modal_trigger)).on('click', function() {
        const $btn = $(this);
        buttonLoadVideo($btn);
      });
    }
  };

  Drupal.behaviors.video_embed = {
    attach: function(context, settings) {
      let $drupalIframe = $('iframe.media-oembed-content', context);
      let $videoIframe = $('iframe', context);

      if ($videoIframe.length > 0 && ($videoIframe[0].src.startsWith('https://vimeo.com') || $videoIframe[0].src.startsWith('https://player.vimeo.com'))) {
        // eslint-disable-next-line no-undef
        let player = new Vimeo.Player($videoIframe);
        parent.document.addEventListener('play', function() {
          player.play();
        });
      }

      if ($drupalIframe.length > 0) {
        let $trigger = $('.remote-video-embed', context);
        let $target = $('.video-embed-wrapper', context);
        let playEvent = new CustomEvent('play');

        $trigger.on('click', function() {
          $trigger.addClass('hide');
          $target.removeClass('hide');
          document.dispatchEvent(playEvent);
        });
      }
    }
  };
})(jQuery, Drupal, once);
